export default __webpack_public_path__ + "static/media/Inter-Italic.e2f52803.woff2";